export function applyEventsChanges(event, updatedEvent) {
    event.id = updatedEvent.id;
    event.participants = updatedEvent.participants;
    event.totalMarketsCount = updatedEvent.totalMarketsCount;
    event.marketLinesCount = updatedEvent.marketLinesCount;
    event.marketGroups = updatedEvent.marketGroups;
    event.startEventDate = updatedEvent.startEventDate;
    event.status = updatedEvent.status;
    event.score = updatedEvent.score;
    event.isLive = updatedEvent.isLive;
    event.liveGameState = updatedEvent.liveGameState;
    event.isSuspended = updatedEvent.isSuspended;
    event.metadata = updatedEvent.metadata;
}
//# sourceMappingURL=applyEventsChanges.js.map